import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 24px 16px 24px;
`;

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`;

export const FieldContainer = styled.div<{ width?: string }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: ${({ width }) => width || '100%'};
  flex: ${({ width }) => (width ? 'none' : '1')};

  .fieldLabel {
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurface};

    .required {
      color: ${({ theme }) => theme.colors.danger.danger};
    }
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
`;

export const BtnContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  padding: 16px 24px;
`;
